module.exports = __webpack_public_path__ + "img/menuTriangeWhite.dd410b61.svg";